import { SVGProps, Ref, forwardRef } from 'react';

export const FlagOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.6 1.736c-2.355.624-3.978.072-5.6-.48-1.925-.655-3.85-1.31-7 0v14.24h1.4v-4.232c2.355-.624 3.978-.072 5.6.48 1.925.655 3.85 1.31 7 0V2l-.536-.536q-.448.162-.864.272M5.062 9.61a9 9 0 0 0-2.662.212v-7.59c.978-.306 1.77-.368 2.457-.317.912.067 1.712.332 2.692.665l.053.018c.934.318 2.04.695 3.336.79.827.06 1.704.006 2.662-.212v7.59c-.978.306-1.77.368-2.457.317-.912-.067-1.712-.332-2.692-.665l-.053-.018c-.934-.318-2.04-.695-3.336-.79"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlagOutlinedSize16Glyph.displayName = 'FlagOutlinedSize16Glyph';
